import { render, staticRenderFns } from "./DsCard.vue?vue&type=template&id=997537d2&scoped=true&"
import script from "./DsCard.vue?vue&type=script&lang=js&"
export * from "./DsCard.vue?vue&type=script&lang=js&"
import style0 from "./DsCard.vue?vue&type=style&index=0&id=997537d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997537d2",
  null
  
)

export default component.exports